import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { getPalette } from 'owa-theme';
import { IconButton } from '@fluentui/react/lib/Button';
import { isToday } from 'owa-observable-datetime';
import { observer } from 'mobx-react-lite';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import getOverflowIndicatorAriaLabel from '../utils/getOverflowIndicatorAriaLabel';

const styles = require('./CalendarMonthSurfaceItem.scss');
const classNames = require('classnames/bind').bind(styles);

export default observer(function CalendarMonthOverflowIndicator({
    item,
    isSelectedDay,
}: {
    item: CalendarEvent;
    isSelectedDay?: boolean;
}) {
    const themeSymbols = getPalette();
    const color = isToday(item.Start) ? themeSymbols.themeDarkAlt : themeSymbols.themePrimary;

    const itemContentWrapperStyle: React.CSSProperties = {
        color,
        cursor: 'pointer',
        height: '100%',
    };

    const label = getOverflowIndicatorAriaLabel(item);

    const wrapperClassName = classNames(
        styles.overflowIndicatorSubject,
        isSelectedDay && styles.isSelectedDay
    );

    return (
        <IconButton
            className={wrapperClassName}
            style={itemContentWrapperStyle}
            iconProps={{ iconName: ControlIcons.More }}
            title={label}
            ariaLabel={label}
        />
    );
});
